import { lazyBus as f, hasLazyLoaded as i } from "../components/Lazy/lazyBus.js";
import { useNavState as v } from "./useNavState.js";
import { freezeAtTop as p } from "@scalar/helpers/dom/freeze-at-top";
import { ref as z } from "vue";
const T = 25, d = 500, I = () => {
  const { hash: c, isIntersectionEnabled: l } = v(), e = z(/* @__PURE__ */ new Set()), t = p(c.value), m = () => {
    t == null || t(), i.value = !0, l.value = !0;
  };
  f.on(({ loading: o, loaded: s, save: n }) => {
    if (!i.value && (o && n && e.value.add(o), s && n && e.value.delete(s), e.value.size === 0)) {
      let r = Date.now();
      const a = () => {
        const u = Date.now();
        if (e.value.size === 0) {
          if (u - r >= d) {
            m();
            return;
          }
        } else
          r = u;
        setTimeout(a, T);
      };
      a();
    }
  });
};
export {
  I as useFreezing
};
